import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import { ElectricalHero, ElectricalContent } from '../components/ElectricalPageSections';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const ElectricalPage = () => {
  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Electrician Carrum - EV Chargers & Switchboards"
        description="Licensed electrician in Carrum and Bayside Melbourne. EV charger installation, switchboard upgrades, lighting and power. Fast, reliable service."
        keywords="electrician Carrum, EV charger installation Bayside, switchboard upgrades Melbourne, light and power Carrum, licensed electrical contractor"
        canonical="https://securelec.net.au/what-we-do/electrical"
      />
      <Header />
      <main>
        <ElectricalHero />
        <ElectricalContent />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ElectricalPage;
